(function () {
  'use strict';

  var SELECTOR = '[data-kidis-picker]:not([data-kidis-picker-ready])';

  function escapeHtml(value) {
    var node = document.createElement('div');
    node.textContent = value || '';
    return node.innerHTML;
  }

  function normaliseHex(value) {
    var clean = String(value || '').replace('#', '').trim();
    return /^[0-9a-f]{3}([0-9a-f]{3})?$/i.test(clean) ? '#' + clean : '';
  }

  function unique(items) {
    return items.filter(function (item, index) {
      return item && items.indexOf(item) === index;
    });
  }

  function sizeValue(label) {
    var text = String(label || '').toLowerCase().replace(',', '.');
    var match = text.match(/([0-9]+(?:\.[0-9]+)?)\s*(ml|cl|l|mg|kg|g|mm|cm|m)\b/);
    if (!match) return Number.POSITIVE_INFINITY;
    var value = Number(match[1]);
    var factors = { ml: 1, cl: 10, l: 1000, mg: 0.001, g: 1, kg: 1000, mm: 1, cm: 10, m: 1000 };
    return value * factors[match[2]];
  }

  function Picker(root) {
    this.root = root;
    this.currentId = String(root.dataset.current || '');
    this.items = [];
    this.expanded = false;
    this.base = root.dataset.endpoint;
    this.status = root.querySelector('[data-kidis-status]');
    this.content = root.querySelector('[data-kidis-content]');
    this.sizeBox = root.querySelector('[data-kidis-sizes]');
    this.sizeBlock = root.querySelector('[data-kidis-size-block]');
    this.sizeLabel = root.querySelector('[data-kidis-size-label]');
    this.colorLabel = root.querySelector('[data-kidis-color-label]');
    this.colors = root.querySelector('[data-kidis-colors]');
    this.search = root.querySelector('[data-kidis-color-search]');
    this.cacheKey = 'kidis-picker-v100:' + (root.dataset.group || '');
  }

  Picker.prototype.seed = function () {
    var d = this.root.dataset;
    return {
      id: d.current || '', url: d.currentUrl || '', title: d.currentTitle || '',
      size: d.currentSize || '', color: d.currentColor || d.currentTitle || '',
      image: d.currentImage || '', swatch: d.currentSwatch || '',
      available: d.currentAvailable === 'true', hex: d.currentHex || ''
    };
  };

  Picker.prototype.merge = function (items) {
    var seen = {}, seed = this.seed();
    var source = (items || []).slice();
    if (!source.some(function (item) { return String(item.id) === String(seed.id); })) source.push(seed);
    this.items = source.filter(function (item) {
      var key = String(item.id || item.url || '');
      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  };

  Picker.prototype.readCache = function () {
    try {
      var stored = sessionStorage.getItem(this.cacheKey) || localStorage.getItem(this.cacheKey);
      var cached = JSON.parse(stored || 'null');
      if (cached && Date.now() - cached.saved < 86400000 && Array.isArray(cached.items)) return cached.items;
    } catch (error) {}
    return null;
  };

  Picker.prototype.writeCache = function () {
    try {
      var value = JSON.stringify({ saved: Date.now(), items: this.items });
      sessionStorage.setItem(this.cacheKey, value);
      localStorage.setItem(this.cacheKey, value);
    } catch (error) {}
  };

  Picker.prototype.endpoints = function () {
    var d = this.root.dataset;
    var group = d.group || '';
    var coll = (d.collectionsUrl || '/collections').replace(/\/$/, '');
    var search = d.searchUrl || '/search';
    var list = [];
    if (this.base) list.push(this.base);
    if (group) {
      list.push(coll + '/all/' + encodeURIComponent(group) + '?view=kidis-group');
      list.push(search + '?view=kidis-group&type=product&options%5Bunavailable_products%5D=last&q=' +
        encodeURIComponent('tag:"' + group + '"'));
    }
    return unique(list);
  };

  Picker.prototype.withTheme = function (url) {
    var theme = window.Shopify && window.Shopify.theme;
    if (theme && theme.id && theme.role !== 'main') {
      url += (url.indexOf('?') > -1 ? '&' : '?') + 'preview_theme_id=' + theme.id;
    }
    return url;
  };

  Picker.prototype.fetchPage = function (base, page) {
    var url = this.withTheme(base + (base.indexOf('?') > -1 ? '&' : '?') + 'page=' + page);
    var requests = window.__kidisGroupRequests || {};
    var request = requests[url] || fetch(url, { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('HTTP ' + response.status);
      return response.text();
    });
    return request.then(function (text) {
      var start = text.indexOf('KIDIS_JSON_START'), end = text.indexOf('KIDIS_JSON_END');
      if (start === -1 || end === -1) throw new Error('no data');
      return JSON.parse(text.slice(start + 16, end));
    });
  };

  Picker.prototype.loadFrom = function (base) {
    var self = this;
    return self.fetchPage(base, 1).then(function (first) {
      var items = first.products || [];
      self.merge(items);
      self.paint(false);
      var pages = Math.min(Number(first.pages) || 1, 12), requests = [];
      for (var page = 2; page <= pages; page += 1) requests.push(self.fetchPage(base, page));
      if (!requests.length) return items;
      return Promise.all(requests).then(function (results) {
        results.forEach(function (data) { items = items.concat(data.products || []); });
        return items;
      });
    });
  };

  Picker.prototype.load = function () {
    var self = this, urls = this.endpoints(), index = 0, best = [];
    this.tried = [];
    function attempt() {
      if (index >= urls.length) return best;
      var url = urls[index++];
      return self.loadFrom(url).then(function (items) {
        self.tried.push(url + ' → ' + items.length);
        if (items.length > best.length) best = items;
        if (items.length > 1) return best;
        return attempt();
      }, function (error) {
        self.tried.push(url + ' → ' + error.message);
        return attempt();
      });
    }
    return attempt().then(function (items) {
      self.merge(items);
      self.writeCache();
    });
  };

  Picker.prototype.currentItem = function () {
    return this.items.find(function (item) {
      return String(item.id) === this.currentId;
    }, this) || this.items[0];
  };

  Picker.prototype.changeSize = function (size, current) {
    if (!size || size === current.size) return;
    var choices = this.items.filter(function (item) { return item.size === size; });
    var target = choices.find(function (item) { return item.color === current.color; }) ||
      choices.find(function (item) { return item.available; }) || choices[0];
    if (target) this.switchTo(target);
  };

  Picker.prototype.renderSizes = function (current) {
    var sizes = unique(this.items.map(function (item) { return item.size; })).sort(function (a, b) {
      var aValue = sizeValue(a), bValue = sizeValue(b);
      if (Number.isFinite(aValue) && Number.isFinite(bValue) && aValue !== bValue) return aValue - bValue;
      if (Number.isFinite(aValue) !== Number.isFinite(bValue)) return Number.isFinite(aValue) ? -1 : 1;
      return String(a).localeCompare(String(b), 'de', { numeric: true });
    });
    this.sizeLabel.textContent = current.size || '';
    this.sizeBlock.hidden = sizes.length < 2;
    this.sizeBox.innerHTML = sizes.map(function (size) {
      var active = size === current.size;
      return '<button type="button" class="kidis-picker__size' + (active ? ' is-active' : '') +
        '" data-kidis-size="' + escapeHtml(size) + '" aria-pressed="' + active + '">' + escapeHtml(size) + '</button>';
    }).join('');
  };

  Picker.prototype.renderColors = function (current) {
    var self = this;
    var query = this.search ? this.search.value.trim().toLowerCase() : '';
    var list = this.items.filter(function (item) {
      return !current.size || item.size === current.size;
    });
    if (query) {
      list = list.filter(function (item) {
        var name = String(item.color || item.title || '').toLowerCase();
        return String(item.id) === String(current.id) || name.indexOf(query) > -1;
      });
    }
    this.colorLabel.textContent = current.color || current.title || '';
    if (!list.length) {
      this.colors.innerHTML = '<li class="kidis-picker__empty">Keine Farbe gefunden</li>';
      return;
    }
    var renderKey = JSON.stringify([current.size, query, list.map(function (item) { return String(item.id); })]);
    if (this.colorRenderKey === renderKey) {
      this.colors.querySelectorAll('[data-kidis-id]').forEach(function (link) {
        var active = link.dataset.kidisId === String(current.id);
        link.parentElement.classList.toggle('is-active', active);
        if (active) link.setAttribute('aria-current', 'page'); else link.removeAttribute('aria-current');
      });
      return;
    }
    this.colorRenderKey = renderKey;
    this.colors.innerHTML = list.map(function (item, index) {
      var active = String(item.id) === String(current.id);
      var color = normaliseHex(item.hex);
      var image = item.image
        ? '<img src="' + escapeHtml(item.image) + '" alt="" width="72" height="72" loading="' + (index < 8 ? 'eager' : 'lazy') + '"' + (index < 4 ? ' fetchpriority="high"' : '') + '>'
        : '';
      var style = color ? ' style="--kidis-swatch-color:' + color + '"' : '';
      var sample = item.swatch
        ? '<img src="' + escapeHtml(item.swatch) + '" alt="" width="80" height="80" loading="' + (index < 8 ? 'eager' : 'lazy') + '">'
        : '';
      return '<li class="kidis-picker__color' + (active ? ' is-active' : '') + (item.available ? '' : ' is-soldout') +
        '" data-kidis-color-name="' + escapeHtml((item.color || '').toLowerCase()) + '">' +
        '<a class="kidis-picker__color-link" data-kidis-id="' + escapeHtml(String(item.id)) + '" href="' + escapeHtml(item.url) + '" aria-label="' + escapeHtml(item.color || item.title) + (item.available ? '' : ', ausverkauft') + '"' + (active ? ' aria-current="page"' : '') + '>' +
        '<span class="kidis-picker__swatch"' + style + '>' + image + '</span>' +
        '<span class="kidis-picker__color-name">' + escapeHtml(item.color || item.title) + '</span>' +
        (item.available ? '' : '<span class="kidis-picker__soldout">Ausverkauft</span>') +
        '<span class="kidis-picker__color-sample" aria-hidden="true">' + sample + '</span></a></li>';
    }).join('');
  };

  Picker.prototype.bindRail = function (box, previous, next) {
    if (!box || !previous || !next) return;
    function update() {
      previous.disabled = box.scrollLeft <= 3;
      next.disabled = box.scrollLeft + box.clientWidth >= box.scrollWidth - 3;
    }
    function move(direction) {
      box.scrollBy({ left: direction * Math.max(box.clientWidth * 0.72, 180), behavior: 'smooth' });
    }
    previous.addEventListener('click', function () { move(-1); });
    next.addEventListener('click', function () { move(1); });
    box.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    requestAnimationFrame(update);
  };

  Picker.prototype.bindControls = function () {
    var self = this;
    if (this.search) {
      this.search.addEventListener('input', function () {
        var current = self.currentItem();
        if (current) self.renderColors(current);
      });
    }
    this.sizeBox.addEventListener('click', function (event) {
      var button = event.target.closest('[data-kidis-size]');
      var current = self.currentItem();
      if (button && current) self.changeSize(button.dataset.kidisSize, current);
    });
    this.bindRail(this.colors, this.root.querySelector('[data-kidis-color-previous]'), this.root.querySelector('[data-kidis-color-next]'));
  };

  Picker.prototype.paint = function (complete) {
    var current = this.currentItem();
    if (!current) return;
    this.renderSizes(current);
    this.renderColors(current);
    this.status.hidden = Boolean(complete);
    this.content.hidden = false;
    this.root.setAttribute('aria-busy', complete ? 'false' : 'true');
  };

  /* ---------- Sofort-Wechsel ohne Neuladen (v45) ---------- */
  var sectionCache = {};
  var imageCache = {};

  Picker.prototype.section = function () {
    return this.root.closest('.shopify-section');
  };

  Picker.prototype.sectionUrl = function (item) {
    var sec = this.section();
    if (!sec || !item.url) return '';
    var id = sec.id.replace('shopify-section-', '');
    return this.withTheme(item.url + (item.url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(id));
  };

  Picker.prototype.prefetch = function (item) {
    if (!item || String(item.id) === this.currentId) return null;
    var key = String(item.id);
    if (item.big && !imageCache[key]) { imageCache[key] = new Image(); imageCache[key].src = item.big; }
    if (sectionCache[key]) return sectionCache[key];
    var url = this.sectionUrl(item);
    if (!url) return null;
    sectionCache[key] = fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    });
    sectionCache[key].catch(function () { delete sectionCache[key]; });
    return sectionCache[key];
  };

  Picker.prototype.findItem = function (id) {
    return this.items.find(function (item) { return String(item.id) === String(id); });
  };

  Picker.prototype.mainImage = function () {
    var sec = this.section();
    if (!sec) return null;
    var imgs = sec.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      if (!this.root.contains(imgs[i]) && imgs[i].getBoundingClientRect().width > 200) return imgs[i];
    }
    return null;
  };

  Picker.prototype.switchTo = function (item, fromHistory) {
    var self = this;
    if (!item || String(item.id) === this.currentId) return;
    var request = this.prefetch(item);
    if (!request) { window.location.assign(item.url); return; }

    /* 1. Sofort sichtbar: Auswahl, Bild, Preis */
    this.currentId = String(item.id);
    this.paint(true);
    var img = this.mainImage();
    if (img && item.big) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = item.big; }
    var sec = this.section();
    if (sec && item.price) {
      var price = sec.querySelector('.price__current, [data-product-price], .price-item--regular, .product__price');
      if (price) price.textContent = item.price;
    }
    if (!fromHistory) history.pushState({ kidisId: item.id }, '', item.url);
    document.title = (item.title || document.title);

    /* 2. Restliche Daten (Lieferzeit, Warenkorb, Bilder) austauschen */
    request.then(function (html) {
      if (self.currentId !== String(item.id) || !self.root.isConnected) return;
      var holder = document.createElement('div');
      holder.innerHTML = html;
      var fresh = holder.querySelector('.shopify-section') || holder.firstElementChild;
      var current = self.section();
      if (!fresh || !current) throw new Error('no section');
      var freshPicker = fresh.querySelector('[data-kidis-picker]');
      if (!freshPicker) throw new Error('no picker');
      var scrollLeft = self.colors.scrollLeft;
      Object.keys(freshPicker.dataset).forEach(function (key) {
        if (key !== 'kidisPickerReady') self.root.dataset[key] = freshPicker.dataset[key];
      });
      fresh.id = current.id;
      freshPicker.replaceWith(self.root);
      current.replaceWith(fresh);
      self.colors.style.scrollBehavior = 'auto';
      self.colors.scrollLeft = scrollLeft;
      self.colors.style.removeProperty('scroll-behavior');
      var canonical = document.querySelector('link[rel="canonical"]');
      if (canonical) canonical.href = new URL(item.url, location.origin).href;
      start();
      document.dispatchEvent(new CustomEvent('kidis:product-changed', { detail: { id: item.id, url: item.url } }));
    }).catch(function () {
      if (self.currentId === String(item.id) && self.root.isConnected) window.location.assign(item.url);
    });
  };

  Picker.prototype.bindInstant = function () {
    var self = this;
    function itemFrom(event) {
      var link = event.target.closest && event.target.closest('[data-kidis-id]');
      return link ? self.findItem(link.dataset.kidisId) : null;
    }
    ['pointerenter', 'touchstart', 'focusin'].forEach(function (type) {
      self.colors.addEventListener(type, function (event) { self.prefetch(itemFrom(event)); }, { passive: true, capture: true });
    });
    this.colors.addEventListener('click', function (event) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button) return;
      var item = itemFrom(event);
      if (!item) return;
      event.preventDefault();
      self.switchTo(item);
    });
    /* Im Leerlauf die ersten Farben vorladen (nicht bei Datensparmodus) */
    var conn = navigator.connection || {};
    if (conn.saveData || /2g/.test(conn.effectiveType || '')) return;
    var idle = window.requestIdleCallback || function (cb) { return setTimeout(cb, 1200); };
    idle(function () {
      var cur = self.currentItem();
      self.items.filter(function (i) { return !cur.size || i.size === cur.size; })
        .slice(0, 8).forEach(function (i) { self.prefetch(i); });
    });
  };

  window.addEventListener('popstate', function () {
    var root = document.querySelector('[data-kidis-picker-ready]');
    var picker = root && root.__kidisPicker;
    var path = location.pathname;
    var item = picker && picker.items.find(function (i) { return i.url && new URL(i.url, location.origin).pathname === path; });
    if (item) picker.switchTo(item, true); else location.reload();
  });

  Picker.prototype.init = function () {
    var self = this;
    this.root.setAttribute('data-kidis-picker-ready', 'true');
    this.root.__kidisPicker = this;
    this.merge([]);
    this.paint(false);
    var cached = this.readCache();
    if (cached && cached.length > 1) {
      this.merge(cached);
      this.paint(true);
      this.bindControls();
      this.bindInstant();
      return;
    }
    this.load().then(function () {
      var current = self.currentItem();
      if (!current || self.items.length < 2) throw new Error('empty group');
      self.paint(true);
      self.bindControls();
      self.bindInstant();
    }).catch(function () {
      self.status.textContent = 'Die Farbauswahl konnte nicht geladen werden.';
      if (window.console) console.warn('[Kidis Farbauswahl] Gruppe: ' + (self.root.dataset.group || '-'), self.tried);
      self.root.setAttribute('aria-busy', 'false');
    });
  };

  function start() {
    document.querySelectorAll(SELECTOR).forEach(function (root) {
      new Picker(root).init();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();
